<template>
  <div>
    <div class="mb-3">
      <div class="headline primary--text mb-1">Real-time Performance</div>
      <div class="subtitle">
        Updated at:
        <template v-if="updatedAt">{{ updatedAt | DateFormat('DD/MM/YYYY HH:mm') }}</template
        ><template v-else>-</template>
      </div>
    </div>

    <v-data-table
      id="realtimePerformance"
      :headers="headers"
      hide-actions
      :items="items"
      :pagination="{ rowsPerPage: -1 }"
      :total-items="items.length"
      class="elevation-1"
      :loading="loading"
    >
      <template #items="{ item }">
        <td style="text-transform: capitalize">{{ item.channel }}</td>
        <td class="text-xs-right">{{ item.total_case_count || 0 }}</td>
        <td class="text-xs-right">{{ item.sl || 0 | decimalFormat(2) }}%</td>
        <td class="text-xs-right">{{ item.pending_case_count || 0 }}</td>
        <td class="text-xs-right">
          {{ handleGetMaxPendingDelayed(item) }}
        </td>
        <td class="text-xs-right">{{ item.nps_avg || 0 | decimalFormat(2) }}%</td>
        <td class="text-xs-right">{{ item.osat_top_box || 0 | decimalFormat(2) }}%</td>
        <td class="text-xs-right">{{ item.osat_top_2box || 0 | decimalFormat(2) }}%</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ttbApi from '@/api/ttb'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  filters: {
    minutes(value) {
      const seconds = value % 60
      const minutes = Math.floor(value / 60)
      const padZero = (number) => (number > 99 ? number : number.toString().padStart(2, '0'))
      return `${padZero(minutes)}:${padZero(seconds)}`
    }
  },
  data() {
    return {
      updatedAt: undefined,
      items: [],
      headers: [
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Total offered', value: 'total_case_count', sortable: false, align: 'right' },
        { text: '%SL', value: 'sl', sortable: false, align: 'right' },
        { text: 'Pending', value: 'pending_case_count', sortable: false, align: 'right' },
        {
          text: 'Max pending',
          sortable: false,
          align: 'right'
        },
        { text: '%NPS', value: 'nps_avg', sortable: false, align: 'right' },
        { text: '%OSAT TOP BOX', value: 'osat_top_box', sortable: false, align: 'right' },
        { text: '%OSAT TOP 2 BOX', value: 'osat_top_2box', sortable: false, align: 'right' }
      ],
      loading: true,
      fetchInterval: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    this.loading = true
    await this.handleGetRealtimePerformance()
    // fetch every 30 secs
    this.fetchInterval = setInterval(async () => {
      if (this.loading) return
      await this.handleGetRealtimePerformance()
    }, 1000 * 30)
    this.loading = false
  },
  beforeDestroy() {
    clearInterval(this.fetchInterval)
  },
  methods: {
    handleGetMaxPendingDelayed(item) {
      if (!item.max_load_start_count || !item.max_load_end_count) {
        return '-'
      }
      return `${moment(item.max_load_start_count).format('HH:mm')} -  ${moment(
        item.max_load_end_count
      ).format('HH:mm')}`
    },
    async handleGetRealtimePerformance() {
      try {
        const updatedAt = moment()
        const response = await ttbApi.postRealTimePerformance({
          data: {
            page_id: this.selectedBot.pageid,
            date: updatedAt.format('YYYY-MM-DD')
          }
        })
        if (response.data.data) {
          this.items = response.data.data
          this.updatedAt = updatedAt.format()
        } else {
          return {
            status: true,
            data: []
          }
        }
      } catch (error) {
        console.error(error)
        // this.$swal.fire({ type: 'error', text: error.toString() })
        return {
          status: false,
          data: []
        }
      }
    }
  }
}
</script>
<style lang="css">
/* @media screen and (min-width: 1560px) { */
#realtimePerformance th,
#realtimePerformance td {
  font-size: 32px !important;
}
#realtimePerformance td {
  font-weight: bold !important;
}
/* } */
</style>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/RealtimePerformance.vue